import React, { useContext } from 'react'
import { connect } from 'react-redux'
import { getNercGroup, saveNercGroup, deleteNercGroup } from 'api/pgads'
import {
  getUnitNameMap,
  getApiTargetInfo,
  getUnits,
  getUtilityNameMap,
  getUnitTypeCode,
  getUnitGroups,
} from 'core/selectors'
import GenericEditScreen, {
  RowButtons,
  RowContainer,
} from 'core/component/GenericEditScreen'
import styled from '@emotion/styled'
import moment from 'moment'
import NercGroupModal from './NercGroupMadal'
import { Filler } from '../../../core/screen-util'
import { DatePicker } from 'antd'
import { DatePickerContext } from 'context'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
import R from 'ramda'
const GroupLabel = styled.div`
  font-weight: bold;
  font-size: 1.4em;
`
const CountLabel = styled.div`
  font-size: 1.2em;
  color: #777;
  margin-left: 1em;
`
const DateLabel = styled.div`
  font-size: 1em;
  color: #777;
  margin-left: 1em;
`

const NercGroup = props => {
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  // const [selectedDate, setSelectedDate] = useState(date)
  const retrieveTask = apiTargetInfo => date =>
    getNercGroup(apiTargetInfo)(date.format('YYYY-MM-DD'))

  const exportFunc = data => {
    const exData = (data || []).map(u =>
      (u.units || []).map(un => ({
        groupName: u.groupName,
        effectiveDate: u.effectiveDate,
        utility: un.substr(0, 3),
        utilityName: props.utilityNameMap[un.substr(0, 3)] || un.substr(0, 3),
        unit: un,
        unitName: props.unitNameMap[un] || un,
      }))
    )
    const flatData = R.flatten(exData)
    return R.sortWith([
      R.ascend(R.compose(R.toLower, R.prop('groupName'))),
      R.ascend(R.compose(R.toLower, R.prop('unitName'))),
      R.ascend(R.compose(R.toLower, R.prop('utilityName'))),
    ])(flatData)
  }

  const ExportHeader = [
    strCol({
      ident: 'groupName',
      display: 'NERC Group Name',
      width: 200,
    }),
    dateCol({
      ident: 'effectiveDate',
      display: 'Effective Date',
    }),
    strCol({
      ident: 'utilityName',
      display: 'Utility',
      width: 450,
      isRequired: true,
      sortOrder: 'asc',
      // dataFormatter: ({ value }) => props.utilityNameMap[value] || value,
    }),
    strCol({
      ident: 'unitName',
      display: 'Unit',
      width: 450,
      isKey: true,
      sortOrder: 'asc',
      // dataFormatter: ({ value }) => props.unitNameMap[value] || value,
    }),
  ]

  const renderModal = ({ hideModal, modalInfo, ...rest }) => (
    <NercGroupModal
      hide={hideModal}
      data={modalInfo}
      availableUnits={props.units}
      unitNameMap={props.unitNameMap}
      utilityNameMap={props.utilityNameMap}
      {...rest}
      unitTypeCode={props.unitTypeCode}
    />
  )
  const renderRow = ({ item, popModal, style, onDelete }) => (
    <RowContainer style={style}>
      <GroupLabel>{item.groupName}</GroupLabel>
      <CountLabel>{item.units.length} units</CountLabel>
      <DateLabel>
        <b>Effective Date :</b>{' '}
        {moment(item.effectiveDate).format('MM/DD/YYYY')}
      </DateLabel>
      <Filler />
      <RowButtons
        item={{
          ...item,
          effectiveDate: moment(item.effectiveDate).format('YYYY-MM-DD'),
        }}
        onDelete={onDelete}
        popModal={popModal}
        duplicateClicked={() =>
          popModal({ ...item, isNew: true, effectiveDate: moment() })
        }
      />
    </RowContainer>
  )

  return (
    <GenericEditScreen
      isExportAvaliable
      exportHeaders={ExportHeader}
      exportFunc={exportFunc}
      sort={data =>
        data.sort((d1, d2) =>
          d1 === undefined || d2 === undefined
            ? 1
            : d1.groupName.toLowerCase() <= d2.groupName.toLowerCase()
            ? -1
            : 1
        )
      }
      title="NERC Groups"
      loadApiTask={retrieveTask}
      createApiTask={saveNercGroup}
      updateApiTask={saveNercGroup}
      deleteApiTask={deleteNercGroup}
      renderModal={renderModal}
      renderRow={renderRow}
      rowHeight={50}
      listHeightOffset={360}
      acceptFilter={item => filterText =>
        filterText == null ||
        (item.groupName || '').toLowerCase().includes(filterText.toLowerCase())}
      criteria={() => (
        <div style={{ marginLeft: '30px' }}>
          <label>Effective Date : </label>
          <DatePicker
            id="effectiveDateR"
            allowClear={false}
            format="MM/DD/YYYY"
            value={selectedDate}
            onChange={setSelectedDate}
          />
        </div>
      )}
      getLoadCriteria={() => selectedDate}
      dataMatcher={d1 => d2 =>
        d1.groupName === d2.groupName && d1.effectiveDate === d2.effectiveDate}
    />
  )
}
const mapStateToProps = state => ({
  unitNameMap: getUnitNameMap(state),
  apiTargetInfo: getApiTargetInfo(state),
  units: getUnits(state),
  utilityNameMap: getUtilityNameMap(state),
  unitTypeCode: getUnitTypeCode(state),
  unitGroups: getUnitGroups(state),
})
export default connect(mapStateToProps)(NercGroup)
